import { render } from "./Page6.vue?vue&type=template&id=e433dd30&scoped=true"
import script from "./Page6.vue?vue&type=script&lang=js"
export * from "./Page6.vue?vue&type=script&lang=js"

import "./Page6.vue?vue&type=style&index=0&id=e433dd30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e433dd30"]])

export default __exports__